var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 42,
    viewBox: "0 0 61 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.80431 0C3.51744 0 0 3.47108 0 7.70145V34.2985C0 38.5289 3.51744 42 7.80431 42H53.1957C57.4826 42 61 38.5289 61 34.2985V7.70145C61 3.47108 57.4826 0 53.1957 0H7.80431ZM7.80431 4.19783H53.1957C53.5419 4.19783 53.8772 4.24122 54.1905 4.328L31.1623 25.6534C30.9095 25.8866 30.0851 25.8866 29.8322 25.6534L6.80404 4.328C7.11731 4.24122 7.45256 4.19783 7.79881 4.19783H7.80431ZM4.2539 7.73941L26.9029 28.7123C28.9364 30.5943 32.0526 30.5943 34.0861 28.7123L56.7351 7.73941V34.2931C56.7351 36.2673 55.1907 37.7913 53.1902 37.7913H7.79881C5.79827 37.7913 4.2539 36.2673 4.2539 34.2931V7.73941Z",
    fill: "url(#paint0_linear_1_4612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4612",
    x1: 2.91837,
    y1: 3.67717,
    x2: 54.7996,
    y2: 37.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2093FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.b5bc9e9a783d97c849f9f0891f4a3cec.svg";
export { ForwardRef as ReactComponent };